import { Typography } from '@mui/material';

interface Props {
    text?: string;
    isRequired?: boolean;
    dominantColor?: string;
    isOptional?: boolean;
}

export const LabelAnswer = ({
    text,
    dominantColor,
    isRequired = true,
    isOptional = false,
}: Props) => {
    if (isOptional) {
        return (
            <Typography
                fontFamily="Lucida Sans"
                variant="body2"
                sx={{
                    color: '#4b4b4b',
                    px: { xs: 0, md: 12 },
                }}
            >
                {text}
            </Typography>
        );
    } else {
        return (
            <Typography
                fontFamily="Lucida Sans"
                fontSize="1.2rem"
                fontWeight="700!important"
                textAlign="left"
                color={dominantColor || '#36c'}
                px={{ xs: 0, md: 12 }}
            >
                {text} {isRequired && <span style={{ color: 'red' }}>*</span>}
            </Typography>
        );
    }
};
